import styled from 'styled-components';

export const StyledSpinner = styled.img`
  width: ${({ $width }) => `${$width / 10}rem` || '4rem'};
  height: ${({ $height }) => `${$height / 10}rem` || '4rem'};
  align-self: center;
`;
